module.exports = __webpack_public_path__ + "img/Prize_bg (1).9d6cd305.png";